import React from 'react';
import {connect} from "react-redux";
import styled from "styled-components";
import {Breadcrumb, Button, Icon, Layout, Modal, Spin, Tooltip} from "antd";
import {Link} from 'react-router';
import {BizEvtmEvtNavbarMenu} from "../../components/ck/CkMenu";
import Iconfont from "../../components/Iconfont/Iconfont";
import {bindActionCreators} from "redux";
import {fetchEvt} from "../../redux/actions/evt";
import CkDockPanel from "../../components/CkDockPanel";
import EvtView from "./EvtView";
import EvtPreview from "./EvtPreview";


const {Sider} = Layout;

const MenuSider = styled(Sider)`
  height: calc(100vh - 48px);
`

const SiderPageHeaderTools = styled.div`
    
    display: flex;
    justify-content: space-between;
    line-height: 12px;
    .sph-tool-group{
        display: flex;
        justify-content: flex-end;
        &:first-child{
           justify-content: flex-start;
        }
        
        &>a{
          color: rgba(0, 0, 0, 0.55);
          &:first-child{
            margin-left:0;
          }
          margin-left:11px;
          .icon{
             font-size: 14px;
          }
          &:hover{
             color: #f5222d;
          }
        }
    }
   
`

const MenuSiderA = styled.a`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 180px;
    word-break: keep-all;
    display: block;
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    line-height: 18px;
    margin: 15px 0;
    &:hover{
      color: #f5222d;
    }
`


class EvtMenuSider extends React.Component {

    constructor(props) {

        super(props);
        this.evtPreviewreViewComp = null;
        this.state = {
            enmbermVisible:true,
            viewEventId: this.props.routeParams.evtId,
            viewEventDetailInEditMode: false,
            viewEventDetailDockPanelCollapsed: true,
            viewEventDetailDockPanelTitle: "",
            viewEventDetailDockPanelTabKey: "",
        }

    }

    componentDidMount() {
        this.props.fetchEvt(this.props.routeParams.evtId);
    }

    changeViewEventDetailInEditMode = (inEditMode, activeEventDetailTabKey) => {
        this.setState({
            viewEventDetailInEditMode: inEditMode,
            viewEventDetailDockPanelTabKey: activeEventDetailTabKey
        })
    }

    closeViewPopup = () => {
        var that = this;
        if (this.state.viewEventDetailInEditMode) {
            Modal.confirm({
                title: '您确定要关闭此窗口吗?',
                content: '你更改的内容还没有保存!',
                okText: '是的',
                cancelText: '取消',
                onOk() {
                    that._closeViewPopup();
                },
                onCancel() {

                },
            });
        } else {
            this._closeViewPopup();
        }
    }

    _closeViewPopup = () => {
        this.setState({
            viewEventId: null,
            viewEventDetailDockPanelTitle: null,
            viewEventDetailDockPanelTabKey: "detail",
            viewEventDetailDockPanelCollapsed: true,
            viewEventDetailInEditMode: false,
        })
    }

    openViewPopup = (tabkey = "detail") => {
        this.setState({
            viewEventId: this.props.routeParams.evtId,
            viewEventDetailDockPanelTitle: `活动号:${this.props.routeParams.evtId}`,
            viewEventDetailDockPanelTabKey: tabkey,
            viewEventDetailDockPanelCollapsed: false
        })

    }


    render() {

        const isFetching = this.props.evt && (this.props.evt.isFetching || !this.props.evt.data)

        return (
            [
                <Spin spinning={isFetching} wrapperClassName="full-height" key={`11sdsdf3frt4`}>
                    <MenuSider className="menu-sider" width={200} style={{marginRight: "1px"}} key={`as23id83mn`}>
                        <div className="page-header" style={{height: "70px", marginBottom: "15px", minWidth: "auto"}} key={`117823f6sdsdf34`}>

                            <div className="clearfix">
                                <MenuSiderA
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.openViewPopup();
                                    }}>
                                    {!isFetching ? this.props.evt.data.header.name : "加载中···"}
                                </MenuSiderA>
                            </div>
                            <SiderPageHeaderTools>
                                <div className="sph-tool-group">
                                    <a className="sph-tool" onClick={(e) => {
                                        e.preventDefault();
                                        this.openViewPopup();
                                    }}>
                                        <Tooltip title="编辑">
                                            <Iconfont libname="ckicon" type="edit"/>
                                        </Tooltip>
                                    </a>

                                    <a className="sph-tool" onClick={(e) => {
                                        e.preventDefault();
                                        this.openViewPopup("ticketing")
                                    }}>
                                        <Tooltip title="票务">
                                            <Iconfont libname="ckicon" type="qianbao"/>
                                        </Tooltip>
                                    </a>
                                    <a className="sph-tool" onClick={(e) => {
                                        e.preventDefault();
                                        this.openViewPopup("guestAndAgenda")
                                    }}>
                                        <Tooltip title="嘉宾">
                                            <Iconfont libname="ckicon" type="jiabinguanli"/>
                                        </Tooltip>
                                    </a>
                                    <a className="sph-tool" onClick={(e) => {
                                        e.preventDefault();
                                        this.openViewPopup("guestAndAgenda")
                                    }}>
                                        <Tooltip title="日程">
                                            <Iconfont libname="ckicon" type="liucheng"/>
                                        </Tooltip>
                                    </a>


                                </div>


                                <div className="sph-tool-group">
                                    <a className="sph-tool" onClick={(e) => {
                                        e.preventDefault();
                                        this.openViewPopup("qrcode")
                                    }}>
                                        <Tooltip title="二维码">
                                            <Iconfont libname="ckicon" type="qrcode"/>
                                        </Tooltip>
                                    </a>

                                    <a className="sph-tool" onClick={(e) => {
                                        e.preventDefault();
                                        this.evtPreviewreViewComp.show()
                                    }}>
                                        <Tooltip title="预览">
                                            <Icon type="mobile"/>
                                        </Tooltip>
                                    </a>
                                </div>

                            </SiderPageHeaderTools>
                        </div>


                        <BizEvtmEvtNavbarMenu
                            key={`11sdsdf676g34`}
                            preLocationPath={`/${this.props.routes.slice(1, 5).filter(r => r.path).map(r => r.path).join("/")}`}
                            evtId={this.props.routeParams.evtId}
                            selectedKey={`/${this.props.routes.slice(1, 7).filter(r => r.path).map(r => r.path).join("/")}`}

                        />


                    </MenuSider>
                </Spin>,
                <EvtPreview
                    key={`11sdsdf34`}
                    ref={(comp) => {
                        this.evtPreviewreViewComp = comp
                    }}
                    eventId={!this.props.evt.isFetching && this.props.evt.data ? this.props.evt.data.header.id : null}
                />,
                <CkDockPanel
                    key={`as23id833453mn`}
                    size="large"
                    title={<Breadcrumb><Breadcrumb.Item>{this.state.viewEventDetailDockPanelTitle}</Breadcrumb.Item></Breadcrumb>}
                    collapsed={this.state.viewEventDetailDockPanelCollapsed}
                    onCollapse={this.closeViewPopup}
                    overlayMenu={<div>
                        <Button icon="mobile" onClick={(e) => {
                            e.preventDefault();
                            this.evtPreviewreViewComp.show()
                        }}>预览</Button>
                    </div>}
                >

                    <EvtView evtId={this.state.viewEventId} inEditMode={this.changeViewEventDetailInEditMode} tabsActiveKey={this.state.viewEventDetailDockPanelTabKey}/>

                </CkDockPanel>
            ]
        )
    }
}


EvtMenuSider.contextTypes = {}

EvtMenuSider.defaultProps = {}

EvtMenuSider.propTypes = {}

const mapStateToPorps = state => {
    const evt = state.evt;
    return {evt};
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});

export default connect(mapStateToPorps, mapDispatchToProps)(EvtMenuSider);


// WEBPACK FOOTER //
// ./src/containers/evt/EvtMenuSider.jsx